import type {CompareSubject, CompareSubjectsMap} from '@src/types/compare.ts';
import {createAction} from '@reduxjs/toolkit';

export const setCompareMethod = createAction<string>('SET_COMPARE_METHOD');

export const setCompareSubject = createAction<{
  index: 0 | 1;
  subject: CompareSubject | null;
}>('SET_COMPARE_SUBJECT');

export const setCompareSubjects = createAction<CompareSubjectsMap>(
  'SET_COMPARE_SUBJECTS',
);

export const swapCompareSubjects = createAction('SWAP_COMPARE_SUBJECTS');

export const clearCompareSubjects = createAction('CLEAR_COMPARE_SUBJECTS');
